import { initAllModules, onDelegatedEvent } from './functions.js';

import './SvgCircleElement.js';
import './TooltipsterHtmlElement.js';
import './RepeaterElement.js';
import './TableArrowNavElement.js';
import './elements/InlineFormElement.js';
import './elements/AjaxFormElement.js';
import './elements/AjaxNavigationElement.js';
import './elements/ConditionalRenderElement.js';
import './elements/RangeBubbleElement.js';
import './elements/IntlTelInputElement.js';
import './elements/AutogrowInputElement.js';
import './elements/ElementHrefElement.js';
import './elements/CheckboxeableElement.js';
import './elements/browser-tests/BrowserStepsElement.js';
import './elements/browser-tests/ElementSelectorElement.js';
import './elements/browser-tests/ExpectStepElement.js';
import './elements/browser-tests/ClickStepElement.js';
import './elements/browser-tests/WaitStepElement.js';
import './elements/browser-tests/NavigateStepElement.js';
import './elements/browser-tests/FillStepElement.js';
import './elements/browser-tests/TypeStepElement.js';
import './elements/browser-tests/CheckStepElement.js';
import './elements/browser-tests/EditStepElement.js';
import './elements/WebsocketCanvasElement.js';

window.modules = window.modules || {};
Object.assign(window.modules, {});

window.addEventListener('load', function() {
    initAllModules();

	let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
	tooltipTriggerList.map(function (tooltipTriggerEl) {
		return new bootstrap.Tooltip(tooltipTriggerEl)
	});

	if (location.hash) {
		const hash = location.hash.substring(1);
		const [key, value] = hash.split('=');
		if (key === 'highlight') {

			let ids = value.split(',');

			ids.forEach(id => {
				const element = document.getElementById(id);

				if (element) {
					element.classList.add('highlight');
					element.scrollIntoView();

					setTimeout(() => {
						element.classList.remove('highlight');
					}, 5000);
				}
			});
		}
	}

	// Intento de corregir el problema del overflow en los table-responsive.
	// No funciona bien, queda feo.
	onDelegatedEvent('show.bs.dropdown', document, '.table-responsive', event => {
		let tableResponsive = event.selectorTarget.closest('.table-responsive');
		// tableResponsive.style.overflow = '70px';
		// tableResponsive.style.paddingBottom = '70px';
	});

	onDelegatedEvent('hide.bs.dropdown', document, '.table-responsive', event => {
		let tableResponsive = event.selectorTarget.closest('.table-responsive');
		// tableResponsive.style.overflow = '';
		// tableResponsive.style.paddingBottom = '';
	});
	
});

function module(mod) {$(function() {if (mod.init) {mod.init(); } }); return mod; }

var Main = module(function() {
	
	function init() {
		$('.tooltipster').tooltipster();
		$('.tooltipster-html').tooltipster({
			contentAsHTML: true
		});
	}

	return {
		init: init
	};
}());


var Repeatable = function(target) {
	
	var self = this;

	function init() {

		$(target).delegate('.repeat-add', 'click', function() {
			self.add();
			
			return false;
		});

		$(target).delegate('.repeat-delete', 'click', function() {
			$(this).closest('.repeat-item').remove();
			return false;
		});

	}

	self.add = function() {
		var $div = $(target).find('.repeat-template').first();
		var $clone = $div.clone();

		var rand = _.random(0, 999999);

		$clone.find('label').each(function() {
			if ($(this).attr('for')) {
				$(this).attr('for', $(this).attr('for').replace('0', rand));
			};
		});

		$clone.find('select, input, textarea').each(function() {
			if ($(this).attr('id')) {
				$(this).attr('id', $(this).attr('id').replace('0', rand));
			}
			if ($(this).attr('name')) {
				$(this).attr('name', $(this).attr('name').replace('0', rand));
			}
			$(this).val('');
			$(this).prop('disabled', false);
		});

		$clone.show().addClass('repeat-item');

		$(target).find('.repeat-rows').append($clone);
	}

	init();
};



var KDConditionalForm = module(function() {
	
	function init() {
		$('.kd-conditional-form').each(function() {
			$(this).find('input, select, textarea').each(function() {
				$(this).on('change keydown', _.debounce(function(event) {
					refresh(this);
				}, 200)).change();
			});
		});
	}

	function refresh(sender) {
		var name = sender.name;

		if (name.indexOf('[') > -1) {
			return;
		}

		console.log(name);

		var value = $(sender).val()

		var $form = $(sender).closest('.kd-conditional-form');

		var attrName = 'kd-if-' + name;
		var $elems = $form.find('*[' + attrName + ']');

		$elems.each(function() {
			var expectedValue = $(this).attr(attrName);
			if (expectedValue === value) {
				$(this).show();
				$(this).find('input, select, textarea').prop('disabled', false);
			} else {
				$(this).hide();
				$(this).find('input, select, textarea').prop('disabled', true);
			}
		});
		

		// $section.find('[data-type]').hide();
		// $section.find('[data-type]').find('input, select, textarea').prop('disabled', true);
		
		// var type = $section.find('select[name=type]').val();
		// $section.find('[data-type*='+type+']').show();
		// $section.find('[data-type*='+type+']').find('input, select, textarea').prop('disabled', false);
	}

	return {
		init: init
	};
}());


jQuery.fn.checkAllButton = function (options) {

	var $this = $(this);

	options = Object.assign({
		mainCheckboxSelector: 'input[type=checkbox]', 
		checkboxSelector:'input[type=checkbox]:not(:first)'
	}, options);

	var $mainCheckbox = $this.find(options.mainCheckboxSelector);
	var $checkboxes = $this.find(options.checkboxSelector);

	$mainCheckbox.change(function() {
		if ($(this).is(':checked')) {
			$checkboxes.prop('checked', true);
		} else {
			$checkboxes.prop('checked', false);
		}
	});

	$checkboxes.change(function() {
		if ($(this).is(':checked')) {

		} else {
			$mainCheckbox.prop('checked', false);
		}
	});

}

jQuery.fn.kdRepeater = function (opts) {

    var $parent      	   = $(this);
    var $templateNode      = $parent.find('[role=repeater-template]');
    var compiledTemplate   =  _.template($templateNode.html());
    var $container         = $parent.find('[role=repeater-container]');
    var $footer            = $parent.find('[role=repeater-footer]');
	var $empty			   = $parent.find('[role=repeater-empty]');9
	var lastIndex 		   = -1;
	var itemsCount 		   = 0;	

    var opts = Object.assign({
        containerTag: 'div',
        initialValues: []
    }, opts);

    if ($(this).length > 1) {   
        console.error('kdRepeater: Only one element is allowed');
        return false;
    }

    function init() {
        fillInitialValues();
        bind();
    }

    function fillInitialValues() {
        opts.initialValues.forEach(function(value) {
            addRow(value);
        });

		toggleEmpty();
    }

    function addRow(value) {

        let index = getNextIndex();

		itemsCount++;

        var html = compiledTemplate({index: index, model: value});
        var $row = $(html);
        $row.data('value', value);

        $container.append($row);

		toggleEmpty();

		opts.onAdd && opts.onAdd(value, $row);
		
    }

    function getNextIndex() {
		lastIndex = lastIndex + 1;
		return lastIndex;
    }

	function toggleEmpty() {
		if (itemsCount > 0) {
			$empty.hide();
			$container.show();
			$footer.show();
		} else {
			$empty.show();
			$container.hide();
			$footer.hide();
		}
	}

    function bind() {
		$parent.delegate('*[role=repeater-delete]', 'click', function() {

            var $row = $(this).closest('*[role=repeater-row]').first();
            var value = $row.data('value');
            $row.remove();
			
			itemsCount--;

			toggleEmpty();

            opts.onRemove && opts.onRemove(value);

            return false;
        });
		$parent.delegate('*[role=repeater-deleteall]', 'click', function() {

			if (!confirm('¿Estas seguro?')) {
				return false;
			}

			var $rows = $parent.find('*[role=repeater-row]');
			
            var values = $rows.map(function() {
				return $(this).data('value');
			})
            $rows.remove();
			
			itemsCount = 0;

			toggleEmpty();

            opts.onRemove && opts.onRemove(values);

            return false;
        });
		$parent.delegate('*[role=repeater-add]', 'click', function() {
            addRow({  });
			return false;
        });
    }

    this.addRow = addRow;

    init();

    return this;

};


jQuery.event.special.touchstart = {
	setup: function( _, ns, handle ){
	  if ( ns.includes("noPreventDefault") ) {
		this.addEventListener("touchstart", handle, { passive: false });
	  } else {
		this.addEventListener("touchstart", handle, { passive: true });
	  }
	}
};